import React from 'react';
import {UseFormMethods} from 'react-hook-form';
import styled, {css} from 'styled-components';
import TextInput from '../../Forms/Inputs/TextInput';
import {mediaMinTablet} from '../../constants/customMedia';
import {DisclaimerText} from '../CodBankData.styled';
import {useBankDetailsTranslationContext} from '../context/CodBankDataTranslation.context';
import {UpdateBankDataFormState} from '../hooks/useBankDataForm';

type FormContentProps = Pick<
  UseFormMethods<UpdateBankDataFormState>,
  'getValues' | 'errors' | 'register'
> & {
  disabled?: boolean;
  singleInputPerLine?: boolean;
  orderId?: number;
  reset?: any;
};

export default function CodBankDataFormContent({
  register,
  errors,
  disabled,
  getValues,
  singleInputPerLine,
  orderId,
}: FormContentProps) {
  const {disclaimerText, formState, bicDisclaimerText} =
    useBankDetailsTranslationContext();

  return (
    <WrapForm singleInputPerLine={singleInputPerLine}>
      {typeof orderId !== 'undefined' && (
        <input type="hidden" name="orderId" value={orderId} ref={register()} />
      )}
      <StyledTextInput
        value={getValues('firstName')}
        name="firstName"
        data-testid="firstName"
        label={formState.firstName.placeholder}
        type="text"
        disabled={disabled}
        errorMessage={errors.firstName?.message}
        ref={register({
          required: formState.firstName.messages.empty,
        })}
      />
      <StyledTextInput
        value={getValues('lastName')}
        name="lastName"
        data-testid="lastName"
        label={formState.lastName.placeholder}
        type="text"
        disabled={disabled}
        errorMessage={errors.lastName?.message}
        ref={register({
          required: formState.lastName.messages.empty,
        })}
      />
      <StyledTextInput
        name="iban"
        value={getValues('iban')}
        label={formState.iban.placeholder}
        type="text"
        data-testid="iban"
        disabled={disabled}
        errorMessage={errors.iban?.message}
        ref={register({
          required: formState.iban.messages.empty,
        })}
      />
      <DisclaimerText data-testid="bicDisclaimerText">
        {bicDisclaimerText}
      </DisclaimerText>
      <DisclaimerText data-testid="genericDisclaimerText">
        {disclaimerText}
      </DisclaimerText>
    </WrapForm>
  );
}

const StyledTextInput = styled(TextInput)``;

const WrapForm = styled.div<{singleInputPerLine?: boolean}>`
  display: flex;
  gap: 20px;
  flex-direction: column;
  @media ${mediaMinTablet} {
    flex-direction: row;
    flex-wrap: wrap;

    ${StyledTextInput} {
      flex-basis: 40%;
      flex-grow: 1;

      &:nth-child(odd) {
        margin-left: 20px;
      }

      ${props =>
        props.singleInputPerLine &&
        css`
          flex-basis: 100%;
          &:nth-child(odd) {
            margin-left: 0;
          }
        `}
    }
  }
`;
